import { render, staticRenderFns } from "./DetailedLog.vue?vue&type=template&id=c005f968&scoped=true"
import script from "./DetailedLog.vue?vue&type=script&lang=ts"
export * from "./DetailedLog.vue?vue&type=script&lang=ts"
import style0 from "./DetailedLog.vue?vue&type=style&index=0&id=c005f968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c005f968",
  null
  
)

export default component.exports